import { render } from "./UiPropArguments.vue?vue&type=template&id=30ebff0c"
import script from "./UiPropArguments.vue?vue&type=script&lang=js"
export * from "./UiPropArguments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__